import { getMagazineExcelAPI, getMagazinesAPI } from '@/src/apis/rest/magazine';
import Button from '@/src/components/atom/Button';
import ExcelDownloadButton from '@/src/components/atom/ExcelDownloadButton';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import Table from '@/src/components/atom/Table';
import Typo from '@/src/components/atom/Typo';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Filter from '@/src/components/organism/Filter';
import { NAV_CONST } from '@/src/constants/nav';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import useQueryValues from '@/src/hooks/useQueryValues';
import { magazineListColumn } from '@/src/pages/Magazine/column';
import { magazineFilters } from '@/src/pages/Magazine/filter';
import PATH from '@/src/routes/path';
import { useQuery } from '@tanstack/react-query';
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function MagazineListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
    postedAt: ['magazinePostBeginStartedAt', 'magazinePostBeginEndedAt'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const {
    data: MagazineListData,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['magazines', values, page, pageSize],
    queryFn: () => {
      return getMagazinesAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.magazineManagement}
        breadcrumbList={[NAV_CONST.magazineManagement]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={magazineFilters()}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">매거진 목록</Typo>
              <div className="flex gap-2">
                <ExcelDownloadButton
                  disabled={
                    isError || isFetching || !MagazineListData?.rows?.length
                  }
                  fileName="매거진_리스트"
                  downloadExcelAPI={getMagazineExcelAPI}
                  searchParams={values}
                />
                <Link to={PATH.MAGAZINE_CREATE}>
                  <Button buttonSize="medium" onClick={() => {}}>
                    <div className="flex items-center gap-x-2">
                      <LucideIcon name="Plus" color="white" />
                      매거진 등록
                    </div>
                  </Button>
                </Link>
              </div>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : MagazineListData?.rows || []}
              isPaginationDataMapping
              columnDefs={magazineListColumn(e => {
                navigate(PATH.MAGAZINE_DETAIL.replace(':id', String(e)));
              })}
              total={MagazineListData?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}
